import { infiniteQueryOptions } from "@tanstack/react-query";
import { getPossibleChatParticipants, listMyChats } from "api-client";
import { CHAT_QUERY_KEYS } from "utils";

import { type ChatStore } from "src/chat/ChatStore";

const MY_CHATS_PAGE_SIZE = 20;
const POSSIBLE_CHAT_PARTICIPANTS_PAGE_SIZE = 30;

export function myChatsInfiniteQueryOptions(store: ChatStore, query: string) {
  return infiniteQueryOptions({
    queryKey: [CHAT_QUERY_KEYS.ROOT, CHAT_QUERY_KEYS.MY_CHATS, query],
    queryFn: async ({ pageParam }) => {
      const response = await listMyChats({
        query: { cursor: pageParam, limit: MY_CHATS_PAGE_SIZE, query },
      });
      const page = response.data.data;
      store.mergeChats(page.chats);
      return page;
    },
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => {
      return lastPage.nextCursor;
    },
    staleTime: Infinity,
    gcTime: Infinity,
  });
}

export function possibleChatParticipantsInfiniteQueryOptions(query: string) {
  return infiniteQueryOptions({
    queryKey: [CHAT_QUERY_KEYS.ROOT, "possibleParticipants", query],
    queryFn: async ({ pageParam }) => {
      const response = await getPossibleChatParticipants({
        query: {
          query,
          pageIndex: pageParam,
          pageSize: POSSIBLE_CHAT_PARTICIPANTS_PAGE_SIZE,
        },
      });
      return response.data.data;
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage) => {
      return lastPage.pageInfo.hasNextPage
        ? lastPage.pageInfo.pageIndex + 1
        : undefined;
    },
  });
}
